export default "__VITE_ASSET__CiRNHvlb__"